module.exports = __webpack_public_path__ + "img/2.b127d15c.png";